import {ActionPlanFilters} from '#component/modal/ActionPlanFilterModal';

export function isFiltered(filters: ActionPlanFilters) {
  return filters.categories.length || filters.impactLevels.length;
}
